import React from "react";
import { MenuItem, Select, SelectProps } from "@mui/material";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { useTranslation } from "react-i18next";

const SelectSortBy: React.FC<{ size?: SelectProps["size"] }> = (props) => {
  const { t } = useTranslation();
  return (
    <Select
      displayEmpty
      IconComponent={ExpandMoreRoundedIcon}
      value=""
      inputProps={{ "aria-label": "Without label" }}
      MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
      {...props}
    >
      <MenuItem value="">{t("menu:item.sortBy")}</MenuItem>
      <MenuItem value="title">{t("common:title")}</MenuItem>
      <MenuItem value="quality">{t("menu:item.bestQuality")}</MenuItem>
    </Select>
  );
};

export default SelectSortBy;
